<template>
  <div v-if="offers && offers.length" class="checker-offers-block">
    <div class="main-title">Лучшие предложения</div>

    <div class="checker-card" v-for="checkerOffer in offers" :key="'checker-' + (checkerOffer.id || checkerOffer.link || checkerOffer.name)">
      <div class="checker-card__wrapper">
        <div class="checker-card__left">
          <div class="checker-title">
            <div class="checker-title__logo">
              <img :src="'https://zanimakus.ru' + checkerOffer.logo" alt="" />
            </div>

            <div v-if="hasCheckerPrivileges(checkerOffer)" class="checker-title__wrapper">
              <div class="checker-title__text1">
                <img src="/img/fire.png" alt="">
                <span>{{ checkerOffer.privilege1 }}</span>
              </div>
              <div class="checker-title__text2">
                <span>{{ checkerOffer.privilege2 }}</span>
              </div>
            </div>
          </div>

          <div class="checker-name">Вам одобрен займ <br>в {{ checkerOffer.name }}</div>

          <div class="checker-data">
            <div class="checker-data__text">
              <div>Сумма:</div><span>{{ numberFormat(checkerOffer.amount) }} ₽</span>
            </div>
            <div class="checker-data__text">
              <div>Срок:</div><span>{{ checkerOffer.period }} дн.</span>
            </div>
            <div class="checker-data__text">
              <div>Ставка:</div><span>{{ getCheckerPercentValue(checkerOffer) }} %</span>
            </div>
          </div>

          <div v-if="hasCheckerPrivileges(checkerOffer)" class="checker-title__wrapper__mob">
            <div class="checker-title__text1">
              <img src="/img/fire.png" alt="">
              <span>{{ checkerOffer.privilege1 }}</span>
            </div>
            <div class="checker-title__text2">
              <span>{{ checkerOffer.privilege2 }}</span>
            </div>
          </div>

          <div @click="openLinks(checkerOffer)" class="checker-button">
            <button>ПОЛУЧИТЬ ДЕНЬГИ</button>
          </div>
          <div class="checker-info">{{ checkerOffer.legal_info }}</div>
        </div>

        <div class="checker-card__right">
          <img src="/img/t-showcasev1-girl.png" alt="">
        </div>
      </div>
    </div>

    <div v-if="showAlsoTitle" class="main-title">Также для вас</div>
  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";

export default {
  name: "CheckerOffersBlock",

  props: {
    offers: {
      type: Array,
      default: () => [],
    },
    showAlsoTitle: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    normalizeCheckerValue(value) {
      return String(value ?? "").replace(/[\s\u00A0\u200B-\u200D\uFEFF]+/g, "").trim();
    },

    getCheckerSeedKey(checkerOffer) {
      if (!checkerOffer) return "checker-percent";

      if (checkerOffer.link) return `link:${checkerOffer.link}`;
      if (checkerOffer.id !== undefined && checkerOffer.id !== null && checkerOffer.id !== "") {
        return `id:${checkerOffer.id}`;
      }

      return `name:${checkerOffer.name || ""}|amount:${checkerOffer.amount || ""}|period:${checkerOffer.period || ""}`;
    },

    getFallbackCheckerPercent(checkerOffer) {
      const variants = ["0", "0.1", "0.3", "0.5", "0.7", "0.9", "1"];
      const seed = this.getCheckerSeedKey(checkerOffer);
      let hash = 0;

      for (let index = 0; index < seed.length; index += 1) {
        hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
      }

      return variants[hash % variants.length];
    },

    hasCheckerPrivileges(checkerOffer) {
      const privilege1 = this.normalizeCheckerValue(checkerOffer?.privilege1);
      const privilege2 = this.normalizeCheckerValue(checkerOffer?.privilege2);

      return privilege1 !== "" && privilege2 !== "";
    },

    getCheckerPercentValue(checkerOffer) {
      const percent = this.normalizeCheckerValue(checkerOffer?.percent_mfo);
      return percent !== "" ? percent : this.getFallbackCheckerPercent(checkerOffer);
    },

    numberFormat(value) {
      return Functions.numberFormat(value);
    },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      (offer.links || []).forEach((link) => {
        window.open(link, "_blank");
      });
    },
  },
};
</script>

<style scoped>
.checker-offers-block--after {
  margin-top: 40px;
}

.checker-offers-block .main-title {
  font-size: 28px;
  margin: 20px 0;
  align-self: flex-start;
  color: #fff;
}

.checker-offers-block .checker-card {
  background: #FFE279 url("https://r-zaym.ru/img/second template bg.png");
  width: 100%;
  padding: 32px 56px;
  border-radius: 28px;
  box-shadow: 0 0 14px 0 rgba(50, 46, 46, 0.10);
  position: relative;
  background-size: cover;
  overflow: hidden;
  margin-bottom: 25px;
}

.checker-offers-block .checker-card__wrapper {
  display: flex;
  justify-content: space-between;
}

.checker-offers-block .checker-card__right {
  position: absolute;
  right: -6%;
  bottom: 0;
}

.checker-offers-block .checker-card__right img {
  max-width: 84%;
}

.checker-offers-block .checker-title {
  display: flex;
  align-items: center;
}

.checker-offers-block .checker-title__logo {
  display: flex;
  align-items: center;
}

.checker-offers-block .checker-title__wrapper {
  display: flex;
  align-items: center;
}

.checker-offers-block .checker-title__text1 {
  display: flex;
  align-items: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.30);
  padding: 14px 16px;
  margin-left: 25px;
}

.checker-offers-block .checker-title__text1 span {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin-left: 8px;
}

.checker-offers-block .checker-title__text2 {
  border-radius: 12px;
  border: 2px solid #FFF;
  padding: 13px 16px;
  margin-left: 25px;
}

.checker-offers-block .checker-title__text2 span {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
}

.checker-offers-block .checker-name {
  color: #000;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 25px;
}

.checker-offers-block .checker-data {
  display: flex;
  align-items: center;
}

.checker-offers-block .checker-data__text {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.checker-offers-block .checker-data__text:not(:first-child) {
  margin-left: 32px;
}

.checker-offers-block .checker-data__text span {
  font-size: 20px;
  text-decoration: underline;
  margin-left: 10px;
}

.checker-offers-block .checker-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1000px;
  background: linear-gradient(109deg, #5038CA 0%, #6757C3 98.87%);
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  padding: 17px 37px;
  max-width: 250px;
  margin-top: 40px;
  margin-bottom: 20px;
  transition: all .3s ease-in-out;
}

.checker-offers-block .checker-button button {
  color: #fff;
  transition: all .3s ease-in-out;
  background: transparent;
}

.checker-offers-block .checker-info {
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  width: 59%;
}

.checker-offers-block .checker-button:hover {
  opacity: .85;
}

.checker-offers-block .checker-title__wrapper__mob {
  display: none;
}

@media (max-width: 1199px) {
  .checker-offers-block .checker-card {
    padding: 27px 35px;
  }

  .checker-offers-block .checker-card__right {
    width: 38%;
  }
}

@media (max-width: 992px) {
  .checker-offers-block .checker-title__text1 span,
  .checker-offers-block .checker-title__text2 span {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .checker-offers-block .checker-card__right {
    display: none;
  }

  .checker-offers-block .checker-title {
    flex-direction: column;
    align-items: start;
  }

  .checker-offers-block .checker-title__text1 {
    margin-left: 0;
  }

  .checker-offers-block .checker-title__wrapper {
    display: none;
  }

  .checker-offers-block .checker-title__wrapper__mob {
    display: flex;
    flex-direction: column;
    align-items: self-start;
  }

  .checker-offers-block .checker-name {
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 20px;
  }

  .checker-offers-block .checker-data {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
    gap: 6px;
  }

  .checker-offers-block .checker-data__text {
    display: grid;
    grid-template-columns: 90px 1fr;
    column-gap: 12px;
    justify-content: start;
    width: 100%;
  }

  .checker-offers-block .checker-data__text:not(:first-child) {
    margin-left: 0;
  }

  .checker-offers-block .checker-data__text > div {
    justify-self: start;
  }

  .checker-offers-block .checker-data__text > span {
    justify-self: start;
    text-align: left;
  }

  .checker-offers-block .checker-button {
    margin-top: 30px;
    margin-bottom: 15px;
  }

  .checker-offers-block .checker-card {
    padding: 24px;
  }

  .checker-offers-block .checker-info {
    width: 100%;
  }

  .checker-offers-block .checker-title__text2 {
    margin-left: 0;
    margin-top: 10px;
  }
}

@media (max-width: 430px) {
  .checker-offers-block .main-title {
    font-size: 22px;
    margin: 15px 0;
  }
}
</style>
